<template>
    <div>
        <div v-bind:class="alertClass">
            <countdown ref="countdown" v-bind:auto-start="false" v-bind:time="availableTime" :transform="transform" v-on:end="handleCountdownEnded" @progress="handleCountdownProgress">
                <template slot-scope="props">
                    <strong>Verbleibende Zeit: {{props.hours}} : {{props.minutes}} : {{props.seconds}}</strong>
                </template>
            </countdown>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'time' : Number,
            'currentTime' : Number
        },
        data() {
            return {
                alertClass: 'alert alert-warning'
            }
        },
        computed: {
            availableTime: function() {
                if(this.currentTime > 0){
                    return this.currentTime;
                } else {
                    return this.time*1000*60;
                }
            },
        },
        methods: {
            handleCountdownEnded: function(){
                this.$emit('countdownEnded');
            },
            handleCountdownProgress: function(data){
                this.$emit('emitTime', data);
                if(data.minutes <= 2){
                    this.alertClass = 'alert alert-danger'
                }
            },
            transform: function(props) {
                Object.entries(props).forEach(([key, value]) => {
                    // Adds leading zero
                    const digits = value < 10 ? `0${value}` : value;
                    props[key] = `${digits}`;
                });

                return props;
            }
        }
    }
</script>
